var _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgResultMark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 51 51",
    width: 51,
    height: 51,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 25.5,
    r: 25.5,
    fill: "#9EA2FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "surface1",
    transform: "matrix(1.852999, 0, 0, 1.852999, -3.178094, -4.605406)",
    style: {}
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 17.379 15.172 C 15.379 17.172 13.432 19.111 13.354 19.06 C 13.276 19.009 12.287 17.993 11.498 17.203 C 10.709 16.414 9.991 15.687 9.98 15.687 C 9.925 15.687 8.508 17.145 8.508 17.199 C 8.508 17.266 13.234 21.992 13.301 21.992 C 13.328 21.992 13.512 21.836 13.707 21.641 C 13.902 21.445 15.879 19.465 18.102 17.242 C 20.324 15.02 22.234 13.109 22.348 12.996 L 22.551 12.793 L 22.32 12.559 C 21.734 11.965 21.201 11.48 21.177 11.48 C 21.165 11.48 19.375 13.216 17.371 15.216"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResultMark);
export default __webpack_public_path__ + "static/media/result-mark.2f48ef06173a9814cfc5e1a2d7c21b90.svg";
export { ForwardRef as ReactComponent };